import comp from "./RelatedConceptTable";
export default comp;
